import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlatInstrumentTablesComponent } from '../plat-instrument-tables';


/**
* Component of table of the diameter-specific plate instrument tray information.
*/
@Component({
	selector: 'plat-instrument-tray-tables',
	templateUrl: './plat-instrument-tray-tables.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlatInstrumentTrayTablesComponent extends PlatInstrumentTablesComponent { }
